export default __webpack_public_path__ + "static/media/challenge.9568c0fb.mp3";